import { render, staticRenderFns } from "./AgentCard.vue?vue&type=template&id=495070c2&"
import script from "./AgentCard.vue?vue&type=script&setup=true&lang=js&"
export * from "./AgentCard.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports